export default "__VITE_ASSET__CCe1qSOV__"